export interface Module {
  num: string
  title: string
  paragraphs: string[]
  tags: string[]
}

export const modules: Module[] = [
  {
    num: '01',
    title: 'Évaluation Clinique & Raisonnement Orthophonique™',
    paragraphs: [
      'Structurez plus efficacement les informations issues du bilan, vos observations et votre raisonnement clinique grâce à des outils conçus pour une pratique professionnelle avancée.',
    ],
    tags: [
      'Anamnèse',
      'Grilles d’Observation',
      'Analyse Clinique',
      'Hypothèses',
      'Priorisation',
      'Bilans d’Évolution',
    ],
  },
  {
    num: '02',
    title: 'Projets Thérapeutiques & Objectifs Cliniques™',
    paragraphs: [
      'Transformez les données issues de l’évaluation en projets thérapeutiques structurés, individualisés et mesurables.',
      'Organisez les priorités, objectifs, indicateurs de progression, critères de réévaluation et décisions d’ajustement.',
    ],
    tags: [
      'Priorités',
      'Objectifs',
      'Plans Individualisés',
      'Indicateurs',
      'Réévaluation',
      'Ajustements',
    ],
  },
  {
    num: '03',
    title: 'Bibliothèque d’Interventions & Activités Thérapeutiques™',
    paragraphs: [
      'Accédez à une bibliothèque structurée d’activités professionnelles organisées selon les objectifs thérapeutiques, les capacités ciblées et les possibilités de progression.',
      'Chaque ressource fournit une structure d’utilisation, des niveaux de difficulté, des adaptations, des aides possibles et des critères d’observation.',
    ],
    tags: ['Langage', 'Communication', 'Parole', 'Cognition', 'Progressions', 'Adaptations'],
  },
  {
    num: '04',
    title: 'Séances Orthophoniques Prêtes à Adapter™',
    paragraphs: [
      'Accédez à des structures de séances complètes lorsque vous avez besoin de préparer rapidement une intervention cohérente.',
      'Objectifs, matériel, déroulement, activités, variantes, progressions, observations et critères permettant d’orienter la suite de la prise en soin.',
    ],
    tags: ['Objectifs', 'Matériel', 'Activités', 'Progressions', 'Adaptations', 'Observations'],
  },
  {
    num: '05',
    title: 'Programmes de Prise en Soin & Progressions Cliniques™',
    paragraphs: [
      'Passez de séances isolées à des progressions thérapeutiques structurées autour d’objectifs précis.',
      'Organisez les différentes phases d’intervention, les niveaux de difficulté, les points de contrôle, les réévaluations et les ajustements nécessaires.',
    ],
    tags: ['Programmes', 'Progressions', 'Phases', 'Critères', 'Réévaluations', 'Ajustements'],
  },
  {
    num: '06',
    title: 'Suivi Clinique, Documentation & Coordination™',
    paragraphs: [
      'Suivez l’évolution, organisez vos observations et transformez les informations recueillies en décisions cliniques plus structurées.',
      'Utilisez des fiches d’évolution, indicateurs, notes cliniques, synthèses, outils de réévaluation et supports de coordination professionnelle.',
    ],
    tags: ['Suivi', 'Évolution', 'Documentation', 'Synthèses', 'Réévaluation', 'Coordination'],
  },
]

export interface Bonus {
  label: string
  title: string
  paragraphs: string[]
  tags: string[]
  img: string
}

export const bonuses: Bonus[] = [
  {
    label: 'Bonus 01',
    title: 'Banque de Supports Thérapeutiques Imprimables™',
    paragraphs: [
      'Accédez à des supports thérapeutiques structurés que vous pouvez sélectionner, imprimer et adapter selon vos objectifs et les besoins de vos patients.',
    ],
    tags: [
      'Fiches',
      'Cartes',
      'Tâches Structurées',
      'Exercices Fonctionnels',
      'Supports Imprimables',
    ],
    img: 'https://cdn.magicpatterns.com/uploads/aWuxRbXhYzL7SbNSQT4dX2/d5ec5f44-a005-4e37-a052-68b3d0cc3c7a-mockup.webp',
  },
  {
    label: 'Bonus 02',
    title: 'Pack Réévaluation & Mesure des Progrès™',
    paragraphs: [
      'Visualisez plus clairement l’évolution entre différentes périodes grâce à des outils professionnels de suivi et de comparaison.',
    ],
    tags: ['Grilles de Suivi', 'Comparaisons', 'Indicateurs', 'Réévaluation', 'Synthèses'],
    img: 'https://cdn.magicpatterns.com/uploads/6km7djyqQJ6vXDcKB4NJKm/0b7c4d0c-61ef-4329-8932-4b6d4a6e9d61-mockup.webp',
  },
  {
    label: 'Bonus 03',
    title: 'Boîte à Outils de Généralisation & Transfert™',
    paragraphs: [
      'Structurez le passage des compétences travaillées en séance vers des situations fonctionnelles pertinentes avec des ressources conçues pour organiser progressivement le transfert.',
    ],
    tags: ['Transfert', 'Généralisation', 'Contextes', 'Tâches Fonctionnelles', 'Observation'],
    img: 'https://cdn.magicpatterns.com/uploads/s9eXJuP4WVcGjkE2MbPqw3/e6437d4f-54db-4c00-8cc7-d9f5496dffd9-mockup.webp',
  },
  {
    label: 'Bonus 04',
    title: 'Système de Préparation Express des Séances™',
    paragraphs: [
      'Passez plus rapidement d’un objectif thérapeutique à une structure de séance cohérente grâce à des matrices de sélection, canevas et systèmes d’adaptation.',
    ],
    tags: ['Planification', 'Canevas', 'Sélection', 'Adaptations', 'Progressions'],
    img: 'https://cdn.magicpatterns.com/uploads/xzk6hBbNyHj21pDGd9gDB7/d38ada2c-4716-4e20-a28f-4af04ce6b909-mockup.webp',
  },
  {
    label: 'Bonus 05',
    title: 'Kit de Coordination Clinique & Communication Professionnelle™',
    paragraphs: [
      'Structurez plus efficacement les informations utiles lors de vos échanges avec d’autres professionnels, le patient ou son entourage lorsque cela est pertinent.',
    ],
    tags: ['Synthèses', 'Réunions', 'Transmissions', 'Suivi', 'Coordination'],
    img: 'https://cdn.magicpatterns.com/uploads/7knZJWU1uZCd5QPrYFX8W9/30e6aa97-336b-4e45-b1b6-497592fc6ad7-mockup.webp',
  },
]

export const pains: string[] = [
  'Vous consacrez du temps à préparer vos séances avant même l’arrivée de votre premier patient.',
  'Vous devez constamment trouver ou adapter des activités selon différents objectifs thérapeutiques.',
  'Vos supports, grilles, fiches, activités et outils de suivi sont dispersés dans plusieurs dossiers.',
  'Vous devez individualiser chaque séance selon le profil, les capacités et l’évolution du patient.',
  'Vous observez une difficulté précise, mais devez encore sélectionner la bonne activité et le bon niveau de progression.',
  'Vos prises en soin nécessitent structure, progression, réévaluation et cohérence clinique.',
]

export const coverage: string[] = [
  'Évaluation Clinique',
  'Raisonnement Orthophonique',
  'Objectifs Thérapeutiques',
  'Activités Structurées',
  'Séances Prêtes à Adapter',
  'Progressions Cliniques',
  'Suivi & Réévaluation',
  'Documentation & Coordination',
]

export const included: string[] = [
  'Système Professionnel Complet en 6 Modules',
  '5 Bonus Stratégiques',
  'Outils d’Évaluation & Raisonnement Clinique',
  'Projets Thérapeutiques & Objectifs',
  'Bibliothèque d’Interventions',
  'Séances Prêtes à Adapter',
  'Programmes & Progressions Cliniques',
  'Outils de Suivi & Documentation',
  'Accès à Vie',
  'Livraison Numérique Immédiate',
]

export const without: string[] = [
  'Passer du temps à préparer vos séances',
  'Rechercher constamment de nouvelles activités',
  'Garder vos ressources dispersées dans plusieurs dossiers',
  'Réutiliser les mêmes supports par manque de temps',
  'Reconstruire chaque séance à partir de zéro',
  'Organiser manuellement les progressions',
  'Multiplier les fiches et outils de suivi séparés',
]

export const withSystem: string[] = [
  'Préparez plus rapidement vos prochaines séances',
  'Accédez à des activités et progressions structurées',
  'Retrouvez vos ressources dans un système organisé',
  'Construisez vos séances plus efficacement',
  'Adaptez les ressources selon vos objectifs cliniques',
  'Suivez l’évolution avec des outils structurés',
  'Commencez chaque séance avec une direction claire',
]

export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'Comment fonctionne ORTHOPHONIE PRO™ ?',
    a: 'Après votre achat, vous recevez immédiatement un accès numérique aux six modules et aux cinq bonus stratégiques. Consultez et utilisez les ressources depuis votre ordinateur, tablette ou smartphone.',
  },
  {
    q: 'Est-ce un produit physique ou numérique ?',
    a: 'ORTHOPHONIE PRO™ est entièrement numérique. Aucun produit physique ne sera expédié. Votre accès est disponible après confirmation du paiement.',
  },
  {
    q: 'Est-ce conçu pour des orthophonistes expérimentés ?',
    a: 'Oui. ORTHOPHONIE PRO™ est conçu pour des professionnels qui maîtrisent déjà les fondamentaux de leur métier et recherchent des ressources structurées, des outils cliniques, des activités, des progressions et des séances prêtes à adapter.',
  },
  {
    q: 'Puis-je l’utiliser avec différents profils de patients ?',
    a: 'Oui. Les ressources sont conçues pour être sélectionnées et adaptées selon le profil, l’âge, les capacités, les objectifs thérapeutiques, le contexte fonctionnel et l’évolution du patient.',
  },
  {
    q: 'Les séances sont-elles identiques pour tous les patients ?',
    a: 'Non. ORTHOPHONIE PRO™ n’est pas un ensemble de protocoles rigides. Les séances constituent des structures professionnelles que l’orthophoniste adapte selon son bilan, son raisonnement clinique et les besoins individuels du patient.',
  },
  {
    q: 'Puis-je modifier et adapter le matériel ?',
    a: 'Oui. Chaque ressource fournit une base professionnelle que vous pouvez adapter à vos objectifs thérapeutiques, votre pratique, votre patient et votre propre raisonnement clinique.',
  },
  {
    q: 'Les cinq bonus sont-ils inclus ?',
    a: 'Oui. Pendant cette offre, les cinq bonus stratégiques sont inclus sans frais supplémentaires.',
  },
  {
    q: 'Combien de temps vais-je conserver l’accès ?',
    a: 'Votre achat comprend un accès à vie aux ressources numériques incluses dans votre commande.',
  },
  {
    q: 'Qu’est-ce qui différencie ORTHOPHONIE PRO™ des ressources gratuites disponibles en ligne ?',
    a: 'Les ressources gratuites sont souvent dispersées et indépendantes les unes des autres. ORTHOPHONIE PRO™ rassemble évaluation, objectifs, activités, séances, progressions, suivi et outils professionnels dans un système cohérent conçu pour faciliter votre organisation clinique.',
  },
  {
    q: 'Comment obtenir de l’aide après mon achat ?',
    a: 'Notre équipe reste disponible par e-mail à kitonline27@gmail.com pour toute question concernant votre accès, l’utilisation des ressources ou la garantie de 7 jours.',
  },
]
